export default __webpack_public_path__ + "static/media/sd-tn-horizontal.7660f28e.svg";